export enum AccountType {
    // 效果广告
    EFFECT = 1,
    // 品牌广告
    BRAND = 2,
    // 游戏联运
    GAME_UNION = 3,
}

export enum ReviewStatus {
    NOT_AUDIT = 0,
    WITH_AUDIT = 1,
    THROUGH = 2,
    NOT_THROUGH = 3,
}

export enum Order {
    DEFAULT = 0,
    ASCEND = 1,
    DESCEND = 2,
}

export enum DeviceOsType {
    ALL = 0,
    IOS = 1,
    ANDROID = 2,
}

export enum Gender {
    ALL = 0,
    MAN = 1,
    FEMALE = 2,
}

export enum ProductType {
    ALL = 0,
    KWAI = 1,
    THANOS = 2,
}

//拆分类型：去重、拆分
export enum SplitType {
    SPLIT = 1,
    DEDUPLICATE = 2,
}

// pageLoading弹框文案
export enum LoadingTextType {
    NORMAL = 0,
    SPLIT = 1,
}

export const AGE_ENUM = [
    {
        label: '全部',
        value: 0,
        unlimited: true,
    },
    {
        label: '18~23',
        value: 1,
    },
    {
        label: '24~30',
        value: 2,
    },
    {
        label: '31~40',
        value: 3,
    },
    {
        label: '41~49',
        value: 4,
    },
    {
        label: '50+',
        value: 5,
    },
];

export enum PopulationType {
    UPLOAD = 1, // 上传人群包
    ADVERTISE = 2, // 精准广告转化
    THEME = 3,
    LOGISTIC = 4,
    EXTEND = 5, // 扩展人群包
    CUSTOMIZE = 6,
    PAID = 7, // 三方人群包
    FANS_STAR = 8,
    LIVE_PAID = 9,
    MOBILE_APP = 10,
    ACTIVE_LEVEL = 11,
    INDUSTRY_CATEGORY = 12,
    BUSINESS_INTEREST = 13,
    INDUSTRY_PREFERENCE = 15,
    PRODUCT_KEYWORD = 17,
    PERMEABILITY_LEVEL = 19, // 应用渗透率
    SMALL_SHOP = 20,
    FANS_STAR_NEW = 22,
    INDUSTRY_CATEGORY_NEW = 23,
    ADVERTISE_NEW = 24,
    FANS_STAR_NEW_2 = 25,
    MOBILE_APP_NEW = 26,
    MOBILE_DEVICE = 27, // 平台网络设备
    AGE_SEGMENT = 28,
    DEVICE_PRICE = 29,
    BRAND_TRANSFORM = 33, // 品牌广告转化
    REGION = 32,
    LOGISTIC2 = 34,
    SEARCH_KEYWORD = 39,
    STAPLE_CONSUME = 35,
    SEX = 36,
    FANS_STAR_NEW_3 = 37,
    SHOP_ATTENTION = 41, // 购物意图
    BEHAVIOR_INTEREST = 43, // 意向定向
    PROPERTY_STATUS = 44,
    HOUSE_LEVEL = 45,
    CATEGORY_ACTION = 46, // 品类行为
    CONSUMPTION_STRATIFICATION = 47,
    SHOP_INTENTION = 48,
    SHOP_USER_LEVEL = 49,
    SHOP_FANS_LEVEL = 50,
    TAG_RECOMMEND = 51,
    SHOP_CARETIME = 54,
    K_STAR = 57,
    BRAND_BEHAVIOR = 59,
    EDUCATION = 60,
    LIFE_STAGE = 61,
    LIVE_REWARDS = 62,
    S_RECOMMEND = 65, // 系统推荐
    SHOP_FANS_GRADE = 95, // 店铺粉丝团等级
    MZ_GENDER_AGE = 96, // 定制年龄性别
    SHOP_ATTENTION_TIME = 98, // 店铺关注时间
    CATEGORY_CONSUME = 99, // 类目消费频次
    CATEGORY_PRICE = 100, // 类目客单价
    LIVING_ROOM = 105, // 直播间人群
    E_COMMERCE = 106, // 电商关键词
    KEY_WORDS = 110, // 关键词
    BRAND_NEW_ATTRICTIVE = 118, // 品牌星引力
    BRAND_ORIENTATION = 124, // 品牌定向
}

export enum CampaignType {
    DPA = 9,
    TAG = 8,
    DEEPLINK = 7,
    CLUE = 5,
    LAND = 4,
    ECOMMERCE = 3,
    APP = 2,
    PHOTO = 1,
    UNKNOWN = -1,
}

export enum CreativeListType {
    CUSTOM = 1,
    PROGRAM = 2,
}

// 模块升级可能涉及页面路由发生改动
export enum RouterPath {
    FRONT_PAGE = '/recommend',
    MY_POPULATION_PATH = '/market/my_population',
    PROPS_DATA_SOURCE_PATH = '/market/props_data',
}

export const MessageCenterConf = {
    development: {
        APP_ID: 'ks670191923238046957',
        BUSINESS_LINE_ID: 24,
    },
    production: {
        APP_ID: 'ks670191923238046957',
        BUSINESS_LINE_ID: 12,
    },
    beta: {
        APP_ID: 'ks670191923238046957',
        BUSINESS_LINE_ID: 12,
    },
    staging: {
        APP_ID: 'ks670191923238046957',
        BUSINESS_LINE_ID: 12,
    },
};

export const MessageCenterCategory = {
    development: [
        {
            name: '公告通知',
            id: 53,
        },
        {
            name: '系统消息',
            id: 54,
        },
    ],
    production: [
        {
            name: '公告通知',
            id: 30,
        },
        {
            name: '系统消息',
            id: 31,
        },
    ],
    beta: [
        {
            name: '公告通知',
            id: 30,
        },
        {
            name: '系统消息',
            id: 31,
        },
    ],
    staging: [
        {
            name: '公告通知',
            id: 30,
        },
        {
            name: '系统消息',
            id: 31,
        },
    ],
};

export const MessageCenterMsgStatus = [
    {
        name: '全部消息',
        id: '',
    },
    {
        name: '已读消息',
        id: 'HAVE_READ',
    },
    {
        name: '未读消息',
        id: 'UNREAD',
    },
];

export const KnowledgeUrl = {
    development:
        'https://beta-ad-knowledge.corp.kuaishou.com/study-zone/72?category=7254&allType=course',
    production: 'https://knowledge.e.kuaishou.com/study-zone/72?category=7254&allType=course',
    beta: 'https://beta-ad-knowledge.corp.kuaishou.com/study-zone/72?category=7254&allType=course',
    staging:
        'https://beta-ad-knowledge.corp.kuaishou.com/study-zone/72?category=7254&allType=course',
};

export const FangzhouUrl = {
    development: 'https://cdp-dev.jinx.staging.kuaishou.com/overview',
    beta: 'https://fangzhou-preonline.test.gifshow.com/overview',
    staging: 'https://cdp-dev.jinx.staging.kuaishou.com/overview',
    production: 'https://fangzhou.e.kuaishou.com/overview',
};

export const JuxingUrl = {
    development: 'https://k-advertiser.staging.kuaishou.com',
    beta: 'https://k-advertiser.prt.kuaishou.com',
    staging: 'https://k-advertiser.staging.kuaishou.com',
    production: 'https://k.kuaishou.com',
};

// 学习专区跳转链接
export const learnLink =
    'https://docs.qingque.cn/d/home/eZQADUlQqKKqS4g7plWt6zOJB?identityId=De1684u5x9';

// 如何使用运算人群文档链接
export const logicDiagramDocUrl =
    'https://docs.qingque.cn/d/home/eZQDY9Zu5QVoJ75dEPvfL80dD?identityId=CiGG0vevCl';

// 如何使用拆分和去重人群文档链接
export const splitDiagramDocUrl =
    'https://docs.qingque.cn/d/home/eZQAna45svjTRTChR_yVYvent?identityId=1yqIOJk6MT5';

export enum APP_ID_TYPE {
    DSP_APP = 1, // 效果用户appid
    AD_SOCIAL_APP = 2, // 快接单用户appid
    SHANG_JIA_HAO_APP = 3, // 商家号用户appid
    AD_BRAND_APP = 4, // 品牌用户 appid
    AD_DIRECT_ECOM_APP = 5, // 直营电商用户 appid
    AD_ESP = 10, // 磁力金牛用户appid
    LSP_APP = 15, // 磁力本地推 appid
    KUAIZHAO_APP = 14, // 磁力快招 appid
}

/* 主内容区div id */
export const MAIN_CONTAINER_ID = 'app';

export const topFirstClass = {
    gender: '性别',
    age: '年龄',
    province: '常住地-省份',
    city: '常住地-城市',
    city_v2: '常住地-城市',
    city_level: '居住分层-城市等级',
    resident_city_level: '居住分层-城市等级',
    region: '居住分层-居住地类型',
    estate_level: '居住分层-小区水平',
    device_brand: '手机品牌',
    device_type: '手机型号',
    os_type: '手机系统',
    isp: '运营商',
    device_price_v2: '设备价格',
    device_price: '设备价格',
    follow_fever_label: '快手网红类型',
    follow_fever_author_follow: '快手网红-关注',
    follow_fever_author_photo: '快手网红-视频互动',
    follow_fever_author_live: '快手网红-直播互动',
    user_activity: '活跃度',
    kstar_fans: 'K-Star粉丝人群',
    kstar_interests: 'K-Star兴趣人群',
    consumption_stratification: '用户消费分层',
    category_behavior_intent: '品类行为',
    workday_timeslot: '工作日使用时段',
    weekend_timeslot: '休息日使用时段',
    app_type: '应用安装类型',
    interest_1: '意向定向',
    interest_2: '意向定向',
    interest_3: '意向定向',
    behavior: '行为定向',
    car_purchase_desire: '汽车购买意图',
    car_price: '汽车价格',
    car_type: '汽车类型',
    car_power: '汽车动力',
    car_seat: '汽车座位',
    car_crowd_type: '汽车人群类型',
    used_car_preference: '二手车偏好',
    car_brand: '汽车品牌',
    consumer_group: '九大消费人群',
    photo_category_interest: '视频类型偏好',
    cdp_b_6r: '品牌6r人群',
    cdp_b_noc: '品牌新老客',
    education: '学历',
    has_house: '是否有房',
    life_stage_marriage: '人生阶段-婚姻状态',
    life_stage_birth: '人生阶段-生育状态',
    life_stage_child_age: '人生阶段-育儿状态',
    app_name: '应用安装名称',
    live_rewards_times: '直播打赏-打赏频次',
    live_rewards_amount: '直播打赏-打赏金额',
    shopping_intention_1: '购物意图',
    shopping_intention_2: '购物意图',
    photo_tag_favor: '兴趣视频',
    business_interest: '商业兴趣',
    follow_favor: '网红粉丝',
    app_behavior: 'app行为',
    pay_ability: '消费能力',
    topFeature: 'TOP20 品类分布',
    consumption_stratification_per_amount: '品类消费客单价分层',
    consumption_stratification_category: '购买品类分布',
    consumption_stratification_amount: '品类消费金额分层',
    consumption_stratification_freq: '消费频次分层',
    category_behavior_purchase_1: '品类购买行为（一级类型）',
    category_behavior_purchase_2: '品类购买行为（二级类型）',
    category_behavior_browse_1: '品类浏览互动行为（一级类型）',
    category_behavior_browse_2: '品类浏览互动行为（二级类型）',
    follow_fever_follow_1: '网红关注偏好（一级类型）',
    follow_fever_follow_2: '网红关注偏好（二级类型）',
    follow_fever_follow_3: '关注网红名称', // 同 网红关注偏好（二级类型）
    // DMP元数据改动
    cdp_b_f: '自然内容短视频偏好（一级类型）',
    cdp_b_s: '自然内容短视频偏好（二级类型）',
    fans_star_level: '粉丝资产', // 品牌
    fans_level: '粉丝资产', // 达人

    //  购买行为
    category_behavior_purchase_1_photo: '品类购买行为（一级类型-短视频）',
    category_behavior_purchase_1_live: '品类购买行为（一级类型-直播视频）',
    category_behavior_purchase_2_photo: '品类购买行为（二级类型-短视频）',
    category_behavior_purchase_2_live: '品类购买行为（二级类型-短视频）',

    // 品类浏览互动行为
    category_behavior_browse_1_photo: '品类浏览互动行为（一级类型-短视频）',
    category_behavior_browse_1_live: '品类浏览互动行为（一级类型-直播）',
    category_behavior_browse_2_photo: '品类浏览互动行为（二级类型-短视频）',
    category_behavior_browse_2_live: '品类浏览互动行为（二级类型-直播）',

    // 互动偏好
    follow_fever_interact_1_photo: '网红互动偏好（一级类型-短视频）',
    follow_fever_interact_1_live: '网红互动偏好（一级类型-直播）',
    follow_fever_interact_2_photo: '网红互动偏好（二级类型-短视频）',
    follow_fever_interact_2_live: '网红互动偏好（二级类型-直播）',
    follow_fever_interact_3_photo: '互动网红-短视频',
    follow_fever_interact_3_live: '互动网红-直播',
};

export const WAN_XIANAG_FUNCTION_CLASS = [
    '平台定制',
    '人群扩展',
    '上传人群',
    '运算人群',
    '门店管理',
    '关键词',
    '数据源',
    '标签专区',
    '相似店铺',
    '去重人群',
    '拆分人群',
];
export const WAN_XIANAG_RECOMMENDED_CLASS = [
    '三方精选',
    '标签推荐',
    '系统推荐',
    '节日专区',
    '主题专区',
    '品牌推荐人群',
    '游戏专区',
    '换季变温专区',
    '春节专区',
    '推荐专区',
    '奥运专区',
];
export const OTHER_PLANT_FORM_CLASS = [
    '磁力智策',
    '画像平台导入',
    '星轨SQL打包',
    'CDP人群',
    'CDP上传人群',
    '品牌客户分层',
    '联合建模',
    '电商推送',
    '流量中台',
    '快手小店',
];
export const EMBED_PLATFORM_LIST = ['juxing'];
